export default __webpack_public_path__ + "static/media/great-punch.9b3c9b28.mp3";